const SearchIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 10.5C1.25 5.39139 5.39139 1.25 10.5 1.25C15.6086 1.25 19.75 5.39139 19.75 10.5C19.75 15.6086 15.6086 19.75 10.5 19.75C5.39139 19.75 1.25 15.6086 1.25 10.5ZM10.5 2.75C6.21981 2.75 2.75 6.21981 2.75 10.5C2.75 14.7802 6.21981 18.25 10.5 18.25C14.7802 18.25 18.25 14.7802 18.25 10.5C18.25 6.21981 14.7802 2.75 10.5 2.75Z"
        fill="#BDBDBD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.08 16.0805C16.3729 15.7876 16.8478 15.7876 17.1407 16.0805L21.3833 20.3232C21.6762 20.6161 21.6762 21.0909 21.3833 21.3838C21.0904 21.6767 20.6156 21.6767 20.3227 21.3838L16.08 17.1412C15.7871 16.8483 15.7871 16.3734 16.08 16.0805Z"
        fill="#BDBDBD"
      />
    </svg>
  );
};

export default SearchIcon;
